var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.offer)?_c('v-col',{staticClass:"mx-auto mt-md-5",staticStyle:{"margin-bottom":"100px"},attrs:{"cols":"12","md":"10","lg":"10"}},[_c('OfferPage',{attrs:{"offer":_vm.offer,"inDialog":false}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }